import { Component } from '@angular/core';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';

@Component({
  selector: 'app-root',
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  location: Location;
  constructor(location: Location) {
    this.location = location;
    let path = this.location.path(true)

    var noHeader = path.includes("courier/payment/online-mobile");


    console.log(this.location.path(true))
  }
}
